import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChannelGatewayComponent } from '@x/ecommerce-shop/app/channel/channel-gateway.component';
import { ChannelHomeComponent } from '@x/ecommerce-shop/app/channel/components/channel-home/channel-home.component';
import { ChannelRouterComponent } from '@x/ecommerce-shop/app/channel/components/channel-router/channel-router.component';
import { channelGatewayGuard } from '@x/ecommerce-shop/app/channel/guards/channel-gateway.guard';
import { channelResolver } from '@x/ecommerce-shop/app/channel/resolvers/channel.resolver';
import { PageNotFoundComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/not-found/page-not-found/page-not-found.component';
import { myAccountUserResolver } from '@x/ecommerce-shop/app/my-account/resolvers/my-account-user.resolver';
import { authGuard } from '../core/auth/guards/auth.guard';

const routes: Routes = [
  {
    path: ':channelCode',
    resolve: { activeChannel: channelResolver },
    component: ChannelRouterComponent,
    children: [
      {
        path: '',
        component: ChannelHomeComponent,
      },
      {
        path: 't',
        loadChildren: () => import('../taxon/taxon.module').then((m) => m.TaxonModule),
      },
      {
        path: 'p',
        loadChildren: () =>
          import('../product-view/product-view.module').then((m) => m.ProductViewModule),
      },
      {
        path: 'pl',
        loadChildren: () =>
          import('../product-listing/product-listing.module').then((m) => m.ProductListingModule),
      },
      {
        path: 'ps',
        loadChildren: () =>
          import('../product-search/product-search.module').then((m) => m.ProductSearchModule),
      },
      {
        path: 'l',
        loadChildren: () => import('../landing/landing.module').then((m) => m.LandingModule),
      },
      {
        path: 'm',
        loadChildren: () =>
          import('../membership/membership.module').then((m) => m.MembershipModule),
      },
      {
        path: 's',
        loadChildren: () =>
          import('../subscription/subscription.module').then((m) => m.SubscriptionModule),
      },
      {
        path: 'my-account',
        canActivate: [authGuard],
        resolve: { myAccountUser: myAccountUserResolver },
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
          import('../my-account/my-account.module').then((m) => m.MyAccountModule),
      },
      { path: '**', component: PageNotFoundComponent },
    ],
  },
  {
    path: '',
    canActivate: [channelGatewayGuard],
    component: ChannelGatewayComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChannelRoutingModule {}
